// extracted by mini-css-extract-plugin
export var dropdownIcon = "_iw-6";
export var imgContainer = "_iw-3";
export var menuIcon = "_iw-5";
export var pillWrapper = "_iw-2";
export var pillsContainer = "_iw-1";
export var subscriptionCard = "_iw-0";
export var subscriptionLogo = "_iw-4";